import PropTypes from "prop-types";

import { buildPrice } from "components/helpers";

/** A labelled invoice total; a null amount renders blank, not $0.00. */
const InvoicesTotal = ({ label, amount }) => (
  <div className="tw:flex tw:flex-col tw:items-end tw:justify-center tw:gap-1">
    <span className="tw:text-sm tw:text-muted-foreground">{label}</span>
    <span className="tw:min-h-8 tw:text-2xl tw:font-semibold tw:text-foreground">
      {amount == null ? "" : buildPrice(amount)}
    </span>
  </div>
);

InvoicesTotal.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number,
};

export default InvoicesTotal;
